export const DOCUMENT_DATA_BY_ID = 'DOCUMENT_DATA_BY_ID';
export const DOCUMENT_DATA = 'DOCUMENT_DATA';
export const DOCUMENT_LEVEL_BY_ID = 'DOCUMENT_LEVEL_BY_ID';
export const DOCUMENT_LEVEL_DATA = 'DOCUMENT_LEVEL_DATA';
export const DISTINCT_DOCUMENT_LEVEL_DATA = 'DISTINCT_DOCUMENT_LEVEL_DATA';
export const DOCUMENT_STATUS = 'DOCUMENT_STATUS';
export const DOCUMENT_HISTORY = 'DOCUMENT_HISTORY';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const SEARCH_DOCUMENT_SUCESS = 'SEARCH_DOCUMENT_SUCESS';
export const NEW_APPROVAL_DOC_DATA = 'NEW_APPROVAL_DOC_DATA';
export const FETCH_WORKFLOW_BY_ID_SUCCESS = 'FETCH_WORKFLOW_BY_ID_SUCCESS';
export const FETCH_WORKFLOW_UPDATE_BY_ID_SUCCESS = 'FETCH_WORKFLOW_UPDATE_BY_ID_SUCCESS';
export const QUERY_LIST_DATA = 'QUERY_LIST_DATA';
export const WORKFLOW_CONFIGURATION_LIST_SUCCESS = 'WORKFLOW_CONFIGURATION_LIST_SUCCESS';
